<template>
    <div :class="`alert alert-${type}`" v-if="message.length > 0">
        {{ message }}
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            type: String,
            message: String
        }
    }
</script>